import { useState, useEffect } from "react";
import { fetchPrestadores } from "../api/healthcareProvidersApi";

export const usePrestadores = (idDep, idMuni, tipo, ese, isOpen, active) => {
  const [prestadores, setPrestadores] = useState([]);

  useEffect(() => {
    // Solo cargar cuando la modal está abierta
    if (!isOpen) {
      return;
    }

    const loadPrestadores = async () => {
      try {
        const data = await fetchPrestadores(idDep, idMuni, tipo, ese, active);
        setPrestadores(data || []);
      } catch (error) {
        console.error("❌ Error cargando prestadores:", error);
        setPrestadores([]);
      }
    };

    loadPrestadores();
  }, [idDep, idMuni, tipo, ese, isOpen, active]);

  return prestadores;
};